//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "../../services/constants";
export default {
  name: "Header",
  data() {
    return {
      user: {
        initials:
          localStorage
            .getItem(server.FULLNAME)
            .split(" ")[1]
            .substring(0, 1) +
          localStorage
            .getItem(server.FULLNAME)
            .split(" ")[2]
            .substring(0, 1),
        fullName: "John Doe",
        email: "defaultmail@mail..com",
        companyname: localStorage.getItem(server.ROLE),
      },
    };
  },

  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    getENV() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    onClickLogOff() {
      this.$store.state.navMenu = false;
      this.$store.dispatch("doLogout");
    },
    resetPassword() {
      // alert("Reset Password");
      this.$router.push("/reset-password");
    },
  },
};
